import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#1B4F72] via-[#154360] to-[#0E2F44] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="assets/logos/mahasarathi-logo.jpg"
                alt="Mahasarathi"
                className="h-12 w-12"
              />
              <span className="text-2xl font-bold">Mahasarathi</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Your integrated multi-modal mobility platform for seamless travel across India.
            </p>
            <div className="flex space-x-4 pt-4">
              <a
                href="https://www.linkedin.com/company/mahasarathi"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#FF9933] transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="https://x.com/MahasarathiMob"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#FF9933] transition-all duration-300 hover:scale-110"
                aria-label="X (Twitter)"
              >
                <Twitter size={18} />
              </a>
              <a
                href="https://www.instagram.com/mahasarathi.official/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#FF9933] transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/features" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  Features
                </Link>
              </li>
              {/* <li>
                <Link to="/pricing" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  Pricing
                </Link>
              </li> */}
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  Contact Us
                </Link>
              </li>
              {/* <li>
                <a href="#" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  Help Center
                </a>
              </li> */}
              {/* <li>
                <a href="/privacy-policy" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms-of-service" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  Terms of Service
                </a>
              </li> */}
              <li>
                <a href="/faq" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  FAQs
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-4">
              {/* <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#FF9933] mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">
                  Electronic City, Bangalore, Karnataka 560100
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-[#FF9933] flex-shrink-0" />
                <a href="tel:+911234567890" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  +91 123 456 7890
                </a>
              </li> */}
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-[#FF9933] flex-shrink-0" />
                <a href="mailto:hello.mahasarathi@gmail.com" className="text-gray-300 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                  hello.mahasarathi@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Mahasarathi. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="privacy-policy" className="text-gray-400 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                Privacy
              </a>
              <a href="/terms-of-service" className="text-gray-400 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                Terms
              </a>
              {/* <a href="#" className="text-gray-400 hover:text-[#FF9933] transition-colors duration-200 text-sm">
                Sitemap
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
